import React, { useState, useImperativeHandle , useRef } from 'react';
import FileEditorModal from './FileEditorModal';
function ImageUpload( { label, gridWidth, icon, name, onUpload, defaultValue, onRemove , visible } , ref ) {
    const containerClass = [
        'image-uploader',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    const fileInputRef = useRef( null );
    const [ showFileModal, setShowFileModal ] = useState( false );
    const [ imageBase64, setImageBase64 ] = useState( defaultValue );
    const [ imageCDNUrl , setImageCDNUrl ] = useState( defaultValue );

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = [ 'image/png', 'image/jpeg', 'image/jpg' ];
        if ( !allowedTypes.includes(file.type) ) {
            alert('Please upload a PNG or JPG image.');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result;
            setImageBase64(base64);
            if ( typeof onUpload === 'function' ) {
                onUpload( base64 );
            }
        };

        reader.readAsDataURL(file);
    };

    const handleRemoveImage = () => {
        setImageBase64( null );
        setImageCDNUrl( null );
        if (typeof onUpload === 'function') {
            onUpload(null);
        }

        if ( fileInputRef?.current?.value ) {
            fileInputRef.current.value = '';
        }
    };

    const toggleFileModal = ( state ) => {
        setShowFileModal( state );
    }

    useImperativeHandle( ref, () => ({
        clear: handleRemoveImage,
    }));

    return(
        <div className={containerClass}>
            <div className="select-image">
                { imageCDNUrl && (
                    <div className="preview">
                        <img src={imageCDNUrl} alt="Uploaded" style={{ maxWidth: '100%', maxHeight: 200 }} />
                        <button type="button" onClick={handleRemoveImage}>
                            <span className="sr-only">remove</span>
                            <svg width="14" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path d="M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
                            </svg>
                        </button>
                    </div>
                )}

                { !imageCDNUrl && (
                    <button type="button" onClick={ () => { toggleFileModal( true ) } } className="blank-preview">
                        <span className="sr-only">Add an Image to the canvas</span>
                        +
                    </button>
                )}
            </div>

            {showFileModal && (
                <FileEditorModal 
                    onClose={() => {
                        toggleFileModal( false )
                    }}
                    onSelectedFile={ ( file ) => {
                        const url = file?.preview_url || "#";
                        setImageCDNUrl( url );
                        if ( typeof onUpload === 'function' ) {
                            onUpload( url );
                        }
                        toggleFileModal( false );
                    }}
                />
            )}
        </div>
    );
}

export default React.forwardRef( ImageUpload );